import React, { memo } from 'react';

const BigPeople = memo(({ size = 70 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M26.3776 36.8293C33.3165 36.8293 38.9417 31.1964 38.9417 24.2479C38.9417 17.2994 33.3165 11.6665 26.3776 11.6665C19.4386 11.6665 13.8135 17.2994 13.8135 24.2479C13.8135 31.1964 19.4386 36.8293 26.3776 36.8293Z"
          stroke="#D2552B"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M46.8586 58.333C46.8907 58.012 46.8907 57.6911 46.8907 57.3701C46.8907 46.0084 37.692 36.8291 26.3779 36.8291C15.0638 36.8291 5.83301 46.0084 5.83301 57.3701C5.83301 57.6911 5.83301 58.012 5.86506 58.333"
          stroke="#D2552B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.6533 11.6665C50.5764 11.6665 56.2174 17.2832 56.2174 24.2479C56.2174 30.0572 52.2431 34.9677 46.8905 36.3799"
          stroke="#D2552B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.8906 36.3794C56.6663 37.92 64.1663 46.3931 64.1663 56.6316C64.1663 56.9525 64.1663 57.2735 64.1342 57.5944"
          stroke="#D2552B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});

export default BigPeople;
